<template>
  <div class="content has-text-grey has-text-centered">
    <p><b-icon icon="exclamation-triangle" size="is-large" /></p>
    <p v-t="'nothing_found'" />
  </div>
</template>

<script>
export default {
  name: 'NothingFound'
}
</script>

<i18n>
{
  "en-US": {
    "nothing_found": "Nothing here."
  },
  "pt-BR": {
    "nothing_found": "Nada encontrado."
  }
}
</i18n>
